import { useEffect, useRef, useCallback } from 'react';
import { useMount } from './useMount';
export function useParticipantsChange(
    zoomVideo: any,
    fn: (participants: any[], updatedParticipants?: any[]) => void
) {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    const callback = useCallback(
        (updatedParticipants?: any[]) => {
            const participants = zoomVideo?.getAllUser();
            fnRef.current?.(participants, updatedParticipants);
        },
        [zoomVideo]
    );
    useEffect(() => {
        if (zoomVideo) {
            zoomVideo?.on('user-added', callback);
            zoomVideo?.on('user-removed', callback);
            zoomVideo?.on('user-updated', callback);
            return () => {
                zoomVideo?.off('user-added', callback);
                zoomVideo?.off('user-removed', callback);
                zoomVideo?.off('user-updated', callback);
            };
        }
    }, [zoomVideo, callback]);
    useMount(() => {
        callback();
    });
}
